import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Pagination from '../../Pagination/Pagination.jsx';
import { Fragment } from 'react';
import toast from 'react-hot-toast';
import { UserContext } from '../../../Context/UserContext.js';
import AddOrderOnlineAdmin from '../AddOrderOnlineAdmin/AddOrderOnlineAdmin.jsx';
import AddOrderCashAdmin from '../AddOrderCashAdmin/AddOrderCashAdmin.jsx';

export default function OrderDashboard() {

   const [orders, setOrders] = useState([]);
   const [ordersData, setOrdersData] = useState({});
   const [filter, setFilter] = useState("");
   const [countItem, setCountItem] = useState(10);
   const { userToken } = useContext(UserContext);
   const [pageCount, setPageCount] = useState(0);

   const header = {
      token: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }


   function searchInput(e) {
      if (e.target.value === "") {
         fetchData();
      }
      if (e.target.value.length >= 4) {
         getSearchData((e.target.value).toLowerCase())
      }
   }



   //& Get All test And Search On Test By Test Name :
   async function getSearchData(search) {
      let limit = 30;
      let keyword = "";
      if (search) {
         keyword = `keyword=${search}`
         limit = 0
      }

      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/order?${keyword}&limit=${limit}`, { headers: header })
         .then(({ data }) => {
            if (data.message === "success") {
               setOrders(data?.orders);
               setPageCount(data.metadata.numberOfPages);
            }
         })
         .catch((error) => {
            toast.error(error.response?.data?.message)
         })
   }


   async function getData() {
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/order/orderCount`, { headers: header })
         .then(({ data }) => {
            if (data.message === "success") {
               setOrdersData(data?.Order_Data);
            }
         })
         .catch((error) => {
            toast.error(error.response?.data?.message)
         })
   }


   async function getTypeOrder(item) {
      setFilter(item)
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/order?filter=${item}`, { headers: header })
         .then(({ data }) => {
            if (data.message === "success") {
               setOrders(data?.orders?.reverse());
               setPageCount(data.metadata.numberOfPages);
            }
         })
         .catch((error) => {
            toast.error(error.response?.data?.message)
         })
   }


   const fetchData = async (currentPage) => {
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/order?page=${currentPage}&filter=${filter}`, { headers: header })
         .then(({ data }) => {
            setOrders(data?.orders);
            setPageCount(data.metadata.numberOfPages);
         })
         .catch((error) => {
            toast.error(error.response?.data?.message)
         })
   }


   const handlePageClick = (data) => {
      fetchData(data?.selected + 1)
   }


   useEffect(() => {
      getData();
      getTypeOrder()
   }, [])


   return (
      <Fragment>
         <div className="container-fluid homeDashboard">
            <h4 className='text-center border-2 border-bottom py-2 fw-bold'>Site Statistics Today</h4>

            <div className="row g-2">

               <div className="col-md-3">
                  <div className='  rounded-2 bg-body-secondary py-1'>

                     <div className='d-flex  align-items-center'>
                        <div className='ms-1 btn-new-color rounded-1 m-1'>
                           <i className="fa-solid fa-house text-white fa-sm p-2"></i>
                        </div>
                        <h4 className='ms-2 m-0 p-0 h6'>Today's Profits</h4>
                     </div>

                     <p className='px-2'>
                        <span>Today : </span>
                        <span className=' text-end'> Cash : <span className=''>{Math.floor(ordersData?.finish_Profits_Cash) ? Math.floor(ordersData?.finish_Profits_Cash) : 0} </span> EGP</span>
                        <span className=' text-end'> bank : <span className=''>{Math.floor(ordersData?.finish_Profits_Online) ? Math.floor(ordersData?.finish_Profits_Online) : 0} </span> EGP</span>
                     </p>
                     <p className='px-2'>
                        <span>Monthly : </span>
                        <span className=' text-end'> Cash : <span className=''>{Math.floor(ordersData?.finish_Profits_Cash_Monthly) ? Math.floor(ordersData?.finish_Profits_Cash_Monthly) : 0} </span> EGP</span>
                        <span className=' text-end'> bank : <span className=''>{Math.floor(ordersData?.finish_Profits_Online_Monthly) ? Math.floor(ordersData?.finish_Profits_Online_Monthly) : 0} </span> EGP</span>
                     </p>

                  </div>
               </div>

               <div className="col-md-3">
                  <div className=' rounded-2 bg-body-secondary py-1'>

                     <div className='d-flex  align-items-center'>
                        <div className='ms-1 btn-new-color rounded-1 m-1'>
                           <i className="fa-solid fa-house fa-sm p-2"></i>
                        </div>
                        <h4 className='ms-2 m-0 p-0 h6'>All Count Orders</h4>
                     </div>

                     <p className='h4 text-end px-2'><span className='h1'>{orders?.length}</span></p>

                  </div>
               </div>

               <div className="col-md-3">
                  <div className=' rounded-2 bg-body-secondary py-1'>

                     <div className='d-flex  align-items-center'>
                        <div className='ms-1 btn-new-color rounded-1 m-1'>
                           <i className="fa-solid fa-house text-white fa-sm p-2"></i>
                        </div>
                        <h4 className='ms-2 m-0 p-0 h6'>New Orders</h4>
                     </div>

                     <p className='h4 text-end px-2'><span className='h1'>{ordersData?.new_Order?.count}</span></p>

                  </div>
               </div>

               <div className="col-md-3">
                  <div className=' rounded-2 bg-body-secondary py-1'>

                     <div className='d-flex  align-items-center'>
                        <div className='ms-1 bg-secondary rounded-1 m-1'>
                           <i className="fa-solid fa-spinner text-white fa-sm p-2"></i>
                        </div>
                        <h4 className='ms-1 m-0 p-0 h6'>Orders Execute</h4>
                     </div>

                     <p className='h4 text-end px-2'><span className='h1'>{ordersData?.executed_Order?.count}</span></p>

                  </div>
               </div>



               <div className="col-md-4">
                  <div className=' rounded-2 bg-body-secondary py-1'>
                     <div className='d-flex  align-items-center'>
                        <div className='ms-1 btn-new-color rounded-1 m-1'>
                           <i className="fa-solid fa-house text-white fa-sm p-2"></i>
                        </div>
                        <h4 className='ms-2 m-0 p-0 h6'>Cancel Orders</h4>
                     </div>
                     <p className='h4 text-end px-2'><span className='h1'>{ordersData?.cancel_Order?.count}</span></p>
                  </div>
               </div>

               <div className="col-md-4">
                  <div className=' rounded-2 bg-body-secondary py-1'>
                     <div className='d-flex  align-items-center'>
                        <div className='ms-1 btn-new-color rounded-1 m-1'>
                           <i className="fa-solid fa-house text-white fa-sm p-2"></i>
                        </div>
                        <h4 className='ms-2 m-0 p-0 h6'>Sampling Orders</h4>
                     </div>
                     <p className='h4 text-end px-2'><span className='h1'>{ordersData?.approvedOrder?.count}</span></p>
                  </div>
               </div>
            </div>

            <div className='my-4 link_home_dashboard'>

               <div className='d-flex justify-content-between align-items-center my-2'>
                  <h5 className='my-3'>Filter By <i className="fa-solid fa-filter ms-2"></i> :</h5>
                  <div>
                     <button className="btn bg-main btn-sm mx-2" data-bs-toggle="modal" data-bs-target="#AddOrderOnlineAdmin">طلب اونلاين</button>
                     <button className="btn bg-main btn-sm mx-2" data-bs-toggle="modal" data-bs-target="#AddOrderCashAdmin">طلب كاش</button>
                     <Link to={"/dashboard/PaidCashOrder"} className="btn bg-main btn-sm mx-2">موافقة طلب كاش</Link>
                  </div>
               </div>

               <div className='d-flex justify-content-between align-items-center my-2'>
                  <form className='w-50'>
                     <label htmlFor="chooseCount" className='me-2'>Count in Page</label>
                     <select className="my-4 w-25" onClick={(e) => { setCountItem(e.target.value) }} name="" id="chooseCount">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="40">40</option>
                     </select>
                  </form>

                  <div className="w-50">
                     <form action="">
                        <label htmlFor="test_search" className='mb-2'>Enter Name, Phone Patient, Order Number</label>
                        <input type="search" onChange={(e) => { searchInput(e) }} className='form-control' id='test_search' placeholder='Search By Patient Name Or Phone Patient' name="search" />
                     </form>
                  </div>
               </div>

               <button onClick={() => { getTypeOrder() }} className='btn btn-dark mx-1 btn-sm'>All Orders</button>
               <button onClick={() => { getTypeOrder("sampling") }} className='btn btn-outline-primary mx-1 btn-sm'>Sampling</button>
               <button onClick={() => { getTypeOrder("cancel") }} className='btn btn-outline-primary mx-1 btn-sm'>Cancel</button>
               <button onClick={() => { getTypeOrder("new") }} className='btn btn-outline-primary mx-1 btn-sm'>Monthly</button>
               <button onClick={() => { getTypeOrder("cash") }} className='btn btn-outline-primary mx-1 btn-sm'>Cash</button>
               <button onClick={() => { getTypeOrder("card") }} className='btn btn-outline-primary mx-1 btn-sm'>Online</button>
            </div>


            {orders.length > 0 ?
               <div className="table">
                  <table className='table table-sm text-center table-group-divider table-striped table-responsive-md '>
                     <thead>
                        <th>Order Number</th>
                        <th>Patient</th>
                        <th>Company</th>
                        <th>Payment</th>
                        <th>Method</th>
                        <th>Net Amount</th>
                        <th>Status</th>
                        <th>Date And Time</th>
                        <th>Action</th>
                     </thead>
                     <tbody>
                        {orders.length ?
                           <>
                              {orders.slice(0, countItem).map((ele) =>
                                 <tr key={ele._id}>
                                    <td>{ele.order_Number}</td>
                                    <td className='fullName'>{ele.patient_Name}</td>
                                    <td>{ele.company?.name}</td>
                                    <td>{ele.total_Price_After_Discount}</td>
                                    <td>{ele.payment_Type}</td>
                                    <td>{ele.Net_Amount}</td>
                                    <td>
                                       {
                                          ele.is_Cancel ?
                                             <p className='alert alert-danger  fw-bold text-center p-1'>إلغاء الطلب</p>
                                             : ele.is_Approved && ele.is_Paid ?
                                                <p className='alert alert-secondary fw-bold text-center p-1 text-success'>تم سحب العينات</p>
                                                : ele.is_Paid ?
                                                   <p className='alert alert-success fw-bold text-center p-1'> تم تسجيل الطلب</p>
                                                   : !ele.is_Paid ?
                                                      <p className='alert alert-success fw-bold text-center p-1'>انتظار موافقة الادمن</p>
                                                      : <p className='alert alert-primary fw-bold text-center p-1' >حدث خطأ اثناء التسجيل</p>
                                       }
                                    </td>
                                    <td>{ele.createdAt.slice(0, 10)}</td>
                                    {/* <td>{ele.createdAt.slice(0 , 10)} <br/> {ele.createdAt.slice(10 ,19 ).split("T")}</td> */}
                                    <td> <Link to={`/dashboard/specificOrder/${ele._id}`} className='btn btn-new-color btn-sm'>More</Link></td>
                                 </tr>
                              )}
                           </> : <div className='alert alert-danger p-1'>Order Not Found</div>}
                     </tbody>
                  </table>
               </div>
               :
               <h3 className='text-center text-danger'>! ... لا يوجد اى طلبات سابقة </h3>
            }

            <AddOrderOnlineAdmin />
            <AddOrderCashAdmin getOrder={getTypeOrder} getData={getData} />
            <Pagination handlePageClick={handlePageClick} pageCount={pageCount} />

         </div>
      </Fragment>
   )
}